// Omgevingen, eigen thema en agendaverbindingen (Engels). Zelfde vorm als omgevingApp.nl.ts.
export const appOmgevingEn = {
    spaces: {
        mine: 'My space',
        switchLabel: 'Switch space',
        choose: 'Choose a space',
        private: 'Private',
        shared: 'Shared',
        dialogTitle: 'Choose your space',
        dialogBody: 'Plan for yourself or together with others.',
        close: 'Close',
        current: 'Current space',
        privateHint: 'Private · just for you',
        sharedHint: 'Shared · plan together',
        opening: 'Opening space…',
        failed: 'Switching did not work. Please try again.',
        personalNotice: 'My space · private: this planning and data are just for you. Switch to Shared at the top to plan together.',
    },
    personalTheme: {
        title: 'My theme',
        body: 'Choose how your app looks. Your choice is saved to your account across devices. The shared board and other users keep their own theme.',
        auto: 'Follow my household theme',
        warm: 'Warm and playful',
        calm: 'Soft and calm',
        minimal: 'Minimal',
        graphic: 'Clean and graphic',
        contrast: 'Large and high contrast',
        failed: 'Your theme could not be loaded.',
        retry: 'Try again',
        saved: 'Your theme has been saved.',
    },
    calendarSync: {
        title: 'My calendar connections',
        intro: 'Connect your primary Google or Microsoft calendar to {name}. Only you manage this connection. Within this space, the usual access rights apply to imported appointments.',
        details: 'Automatically every five minutes, from 30 days back to a year ahead. Repeating appointments are synced as separate appointments. Only the title, times, location and notes are exchanged; no attendees or invitations. Edit meetings with attendees in Google or Outlook.',
        connected: 'Calendar connected. Choose Sync now to start right away.',
        failed: 'Connecting did not work or was cancelled. Please try again.',
        retry: 'Try again',
        provider: 'Calendar service',
        google: 'Google Calendar / Gmail',
        googleShort: 'Google Calendar',
        microsoft: 'Microsoft 365 / Outlook',
        direction: 'Sync direction',
        import: 'Only into AMUMIN',
        export: 'Only from AMUMIN',
        both: 'Both ways',
        scope: 'Which appointments to send?',
        scopeMine: 'Appointments I am part of',
        scopeAll: 'All appointments in this space',
        notConfigured: 'AMUMIN still needs to activate this calendar service. Your existing calendar subscriptions stay available.',
        alreadyConnected: 'Already connected',
        connect: 'Connect calendar',
        lastSync: 'Last synced: {when}',
        neverSynced: 'Not synced yet',
        conflicts: {
            one: '{count} appointment was changed or deleted on both sides. It has been kept. Check both calendars and choose which version to keep.',
            other: '{count} appointments were changed or deleted on both sides. They have been kept. Check both calendars and choose which version to keep.',
        },
        synced: 'Sync complete.',
        syncNow: 'Sync now',
        keepLocal: 'Keep AMUMIN versions',
        keepRemote: 'Keep external versions',
        disconnect: 'Stop connection',
        disconnectHint: 'Stopping does not delete any appointments. To change the direction, stop the connection and connect again.',
        personalLinks: 'Your personal calendar stays private. Create shared subscription links from your shared space.',
    },
    errors: {
        personalSpacePrivate: 'Your personal space is just for you. Switch to Shared to invite people or connect a board.',
        providerNotConfigured: 'AMUMIN has not activated this calendar service yet.',
        alreadyConnected: 'This calendar service is already connected. Stop the existing connection first to connect again.',
    },
    rideOpen: {
        dropoff: 'Who takes {names} to {title}?',
        dropoffNoNames: 'Who drives to {title}?',
        pickup: 'Who picks {names} up from {title}?',
        pickupNoNames: 'Who picks up from {title}?',
    },
    notMeHint: '{link}: use the link at the bottom of the email.',
    ingredientsPlaceholder: '500 g minced meat\n1 onion\n1 tin of tomatoes',
};
//# sourceMappingURL=omgevingApp.en.js.map